import { render } from "./homePage2.vue?vue&type=template&id=621345d0&scoped=true"
import script from "./homePage2.vue?vue&type=script&lang=js"
export * from "./homePage2.vue?vue&type=script&lang=js"

import "./homePage2.vue?vue&type=style&index=0&id=621345d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621345d0"]])

export default __exports__